module.exports = __webpack_public_path__ + "img/56167d5641d4bb58cbe97f00762d411a.png";